<template>
  <div class="text-subtitle-underline">お知らせ</div>
  <template v-if="Array.isArray(notices) && notices.length">
    <ul class="card-outlined pt-3 px-3 md:pt-4 md:px-4">
      <li v-for="notice in notices" :key="notice.id" class="pb-3 md:pb-4">
        <router-link
          :to="`/notice/${notice.id}`"
          class="text-link"
        >
          <div class="flex text-sm md:text-base">
            <div class="leading-tight pr-3">{{ dayjs(notice.published_at).format('YYYY/MM/DD') }} </div>
            <div class="leading-tight">{{ notice.title }}</div>
          </div>
        </router-link>
      </li>
    </ul>
    <div class="text-right">
      <router-link
        to="/notice"
        class="text-link text-sm"
      >
        すべてのお知らせを見る>
      </router-link>
    </div>
  </template>
  <template v-else>
    <div class="h-44 px-2">
      お知らせはありませんでした。
    </div>
  </template>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { dayjs } from '@/plugins/dayjs'
import { NoticeAttributes } from '@/types/models/notice'

export default defineComponent({
  props: {
    notices: {
      type: Array as PropType<NoticeAttributes[] | undefined>,
      'default': () => ([]),
    }
  },
  setup() {
    return {
      dayjs
    }
  },
})
</script>
